import React from 'react';
import {AisinoCheckbox, AisinoFormItem} from "../../../baseComponent/form";

const formItemTailLayout = {wrapperCol: {offset: 1, span: 20},};

class FormItemCheckbox extends React.Component {

    render() {
        return(
            <AisinoFormItem {...formItemTailLayout} {...this.props} onChange={this.props.onChangeItem} valuePropName="checked">
                <AisinoCheckbox checked={this.props.checked} disabled={this.props.disabled} onChange={this.props.onChange}>{this.props.text}</AisinoCheckbox>
            </AisinoFormItem>
        );
    }
}

export default FormItemCheckbox;